import { Select as MuiSelect, SelectProps as MuiSelectProps } from '@mui/material';

export type SelectProps = MuiSelectProps;

export const Select = (props: SelectProps) => {
  return (
    <MuiSelect
      {...props}
      sx={{
        ...props.sx,
      }}
    />
  );
};
